const filtroBusquedaRCDetalleState = {
  loading: false,
  busquedarecargos: false,
  recargosConvenidosExcep: [],
};

export default filtroBusquedaRCDetalleState;




// WEBPACK FOOTER //
// ./src/components/RecargosConvenios/FiltroBusquedaDetalle/state.js